import { authRoles } from 'app/auth';
import EsetleirasTable from 'app/admin/esetleiras/table/EsetleirasTable';
import EsetleirasEditForm from 'app/admin/esetleiras/editform/EsetleirasEditForm';

export default [
	{
		path: '/esetleiras/edit/:id',
		component: EsetleirasEditForm,
		auth: authRoles.admin
	},
	{
		path: '/esetleiras/:sessionNameParam?',
		component: EsetleirasTable,
		auth: authRoles.admin
	}
];
